import ctaFragment from '@lib/fragments/cta-fragment';
import gql from 'graphql-tag';

const storyCardsSectionFragment = gql`
  fragment storyCardsSectionFields on StoryCardsSection {
    backgroundColor: background_color {
      color
    }
    title
    subtitle
    text
    cta {
      ...ctaFields
    }
    cards {
      id: _id
      title
      text
      color
      cta {
        ...ctaFields
      }
      image {
        ...assetFields
        url(preset: "Story", width: 800, format: "webp")
      }
      video {
        youtubeId: youtube_id
        embeddedVideo: embedded_video {
          playbackId: playback_id
        }
        alt: alt_text
        thumbnail {
          ...assetFields
          url(width: 800, height: 1422, format: "webp") # ratio 9:16
        }
      }
    }
  }
  ${ctaFragment}
`;

export default storyCardsSectionFragment;
